
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import {
  formatDate,
  formatDateWithoutTime
} from "@/app/infrastructures/misc/Utils";

class Props {
  detailData = prop<any>({
    default: {},
    type: Object
  });
}

@Options({
  components: {
    Title
  }
})
export default class ProgressiveCommissionConfigurationProgram extends Vue.with(
  Props
) {
  formatDate(date: string) {
    return formatDate(date);
  }

  get startDate() {
    return `${formatDateWithoutTime(this.detailData.startDate, false)}`;
  }

  get endDate() {
    return `${formatDateWithoutTime(this.detailData.endDate, false)}`;
  }
}
